require("-!style!css!./../node_modules/vue-loader/lib/selector.js?type=style&index=0!./Option.vue")
module.exports = require("-!babel?optional[]=runtime!./../node_modules/vue-loader/lib/selector.js?type=script&index=0!./Option.vue")
module.exports.template = require("-!vue-html!./../node_modules/vue-loader/lib/selector.js?type=template&index=0!./Option.vue")



/*****************
 ** WEBPACK FOOTER
 ** ./src/Option.vue
 ** module id = 111
 ** module chunks = 0
 **/